import React from 'react'
import {PostWrapper} from '../elements'

export const Post = ({children}) => {
    return ( <PostWrapper >
                {children}
            </PostWrapper>
    )
}